import { render, staticRenderFns } from "./extendedit.vue?vue&type=template&id=0604cf0b&scoped=true"
import script from "./extendedit.vue?vue&type=script&lang=js"
export * from "./extendedit.vue?vue&type=script&lang=js"
import style0 from "./extendedit.vue?vue&type=style&index=0&id=0604cf0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0604cf0b",
  null
  
)

export default component.exports